// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__3j8du","fileDisabled":"File_fileDisabled__RYt8P"};